import angular from 'angular';

class OrderDraggableTableCtrl {
  /* @ngInject */
  constructor(AuthSvc, ORDER_PARAM) {
    this.AuthSvc = AuthSvc;
    this.ORDER_PARAM = ORDER_PARAM;

    this.tableOptions = { accept: true };
    // verification si il a le role configurateur
    this.isEditAuthorized = AuthSvc.isEditAuthorized();

    this.presenceOptions = ORDER_PARAM.presenceOptions;
  }

  accept(srcNodeScope, dstNodeScope, dstIndex) {
    var attr = this.tableData[dstIndex];
    return !attr.isStandard() && srcNodeScope.$modelValue.section === this.typeSection;
  }

  remove(attribute) {
    this.removeFn({ item: attribute });
  }

  /** Indique si l'utilisateur peut modifier la visibilité d'une donnée sur l'IHM */
  canUpdateVisibility(attribute) /*:boolean*/ {
    return this.isEditAuthorized && !attribute.internalData && !attribute.isStandard();
  }

  updateVisibility(attribute) {
    attribute.visible = attribute.presence.visible;
  }
}

angular.module('app.principal').component('kissOrderDraggableTable', {
  controller: OrderDraggableTableCtrl,
  controllerAs: 'vm',
  templateUrl: require('./order-draggable-table.html'),
  bindings: {
    editable: '<',
    removeFn: '&',
    tableData: '=',
    typeSection: '@'
  }
});
